module.exports = __webpack_public_path__ + "img/gift21.1c82a0e0.png";